import { HubConnection, LogLevel } from "@microsoft/signalr";
import { SignalRFactory } from "@app/core/signalR/signalr-factory";

export abstract class BaseSignalRClass {
  protected hubConnection!: HubConnection;

  constructor(
    protected hubUrl: string,
    protected logLevel: LogLevel,
    protected accessTokenFactory: () => string,
    ) {}

  connection(): void {
    this.hubConnection = SignalRFactory.connection(
      this.hubUrl, this.accessTokenFactory, this.logLevel
    );

    this.hubConnection.start()
      .then(() => console.log(`${this.hubUrl} connected`))
      .catch((err: Error) =>
        console.error(`Error connecting to ${this.hubUrl}:`, err)
      );
  }

  disconnect(): void {
    if (this.hubConnection) {
      this.hubConnection.stop();
    }
  }
}
